import React from 'react'
import Company from '../container/company'

const CompanyPage = (props) => (
  <Company {...props} langKey='en' />
)

export default CompanyPage
